import { useEffect, useRef, useState } from 'react';

// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';

import { Text } from 'ui-components/components/text';
import { Checkbox } from 'ui-components/components/checkbox';
import { FlexRow, Gap } from 'ui-components/components/flex';

import { useReturnConfig } from '../../../return-config-provider';
import { useFulfillmentPlannerContext } from '../../../../../../fulfillment-planner/context';

import { messages } from './messages';
import style from './styles.module.less';

export function ShippingCostWaiveOffCheckbox() {
  const { totalCost } = useFulfillmentPlannerContext();
  const { saveShippingCost } = Details.useShippingInfo();
  const { isShippingFeeWaived, setIsShippingFeeWaived } = useReturnConfig();

  const [debouncedIsShippingFeeWaived, setDebouncedIsShippingFeeWaived] = useState(isShippingFeeWaived);
  const totalCostRef = useRef(totalCost);
  const saveShippingCostRef = useRef(saveShippingCost);

  useEffect(() => {
    totalCostRef.current = totalCost;
  }, [totalCost]);

  useEffect(() => {
    saveShippingCostRef.current = saveShippingCost;
  }, [saveShippingCost]);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedIsShippingFeeWaived(isShippingFeeWaived), 300);
    return () => clearTimeout(handler);
  }, [isShippingFeeWaived]);

  useEffect(() => {
    saveShippingCostRef.current({
      amount: debouncedIsShippingFeeWaived ? 0 : totalCostRef.current?.value,
      currency: debouncedIsShippingFeeWaived ? 'USD' : totalCostRef.current?.code,
    });
  }, [debouncedIsShippingFeeWaived]);

  return (
    <Text
      textType='Label'
      value={
        <FlexRow className={style.checkbox} gap={Gap.Space8}>
          <Checkbox checked={isShippingFeeWaived} onChange={setIsShippingFeeWaived} />
          <Text textType='Paragraph' value={messages.waiveOffShippingCostLabel} />
        </FlexRow>
      }
    />
  );
}
